<template>
    <v-menu
        :close-on-content-click="false"
        bottom
        offset-y
        nudge-bottom="5"
        min-width="310"
    >
        <template v-slot:activator="{ on, attrs }">
            <a
                v-bind="attrs"
                v-on="on"
            >
                <v-icon color="white" size="25" class="nav-icon toolbar-button">mdi-router-wireless</v-icon>
            </a>
        </template>
        <w-site-movements
            :unit = "unit"
            class="white pa-1"
        />
    </v-menu>
</template>

<script>
import WSiteMovements from "@/modules/datahub/components/private/WSiteMovements.vue";
export default {
    name: "CDataHubMenu",
    components: {
        WSiteMovements
    },

    props: {
        unit: {

        }
    }
}
</script>

<style scoped>

</style>